import { render, staticRenderFns } from "./MissionGetPointParts.vue?vue&type=template&id=309cd5dd&scoped=true"
import script from "./MissionGetPointParts.vue?vue&type=script&lang=ts"
export * from "./MissionGetPointParts.vue?vue&type=script&lang=ts"
import style0 from "./MissionGetPointParts.vue?vue&type=style&index=0&id=309cd5dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309cd5dd",
  null
  
)

export default component.exports